import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=6b633ded&scoped=true&"
import script from "./Diagnosis.vue?vue&type=script&lang=js&"
export * from "./Diagnosis.vue?vue&type=script&lang=js&"
import style0 from "./Diagnosis.vue?vue&type=style&index=0&id=6b633ded&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b633ded",
  null
  
)

export default component.exports